import React, {Component} from 'react';
import ReportModulesContainer from '../../../containers/report_module_container';
import CKEditor from "react-ckeditor-component";
import {Button, Form, Header} from "semantic-ui-react";

class CreateModule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            text: '',
            content: 'Add new Module Content after clearing this dummy text',
            moduleName: undefined
        };
    }

    handleChange = (e) => {
        let newContent = e.editor.getData();
        this.setState({
            content: newContent
        })
    };

    handleSubmit = () => {
        const formData = {
            name: this.state.moduleName ? this.state.moduleName : 'module Test',
            contents: this.state.content,
            type: 1
        };
        this.props.createTemplateModule(formData, this.successCallBack);
    };

    successCallBack = (response) => {
        if (response.success) {
            this.props.history.replace('/report/module');
        }
    };


    render() {
        return (
            <div style={{width: "80%", margin: 'auto', paddingTop: '2%'}}>
                <Header size="large" textAlign="left">
                    <span>Create Report Module</span>
                </Header>
                <div className="pad-all">
                    <Form>
                        <Form.Input label="Module Name:" onChange={(e) => {
                            this.setState({moduleName: e.target.value})
                        }} fluid/>
                    </Form>
                </div>
                <CKEditor
                    activeClass="p10"
                    content={this.state.content}
                    events={{
                        "change": this.handleChange
                    }}
                    scriptUrl={"//cdn.ckeditor.com/4.10.0/full/ckeditor.js"}
                    config={{
                        toolbarGroups: [
                            {name: 'document', groups: ['mode', 'document', 'doctools']},
                            {name: 'clipboard', groups: ['clipboard', 'undo']},
                            {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
                            {name: 'forms', groups: ['forms']},
                            {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
                            {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
                            {name: 'links', groups: ['links']},
                            {name: 'insert', groups: ['insert']},
                            {name: 'styles', groups: ['styles']},
                            {name: 'colors', groups: ['colors']},
                            {name: 'tools', groups: ['tools']},
                            {name: 'others', groups: ['others']},
                            {name: 'about', groups: ['about']}
                        ],
                        removeButtons: 'Print,Save,Templates,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Language,Flash,Smiley,Iframe,ShowBlocks,About',
                        height: window.screen.height * 0.35,
                    }}
                />
                <div className="pad-top">
                    <Button primary className="pull-right" onClick={() => {
                        this.handleSubmit()
                    }} content="Create Module"/>
                </div>
            </div>
        )
    }
}

export default ReportModulesContainer(CreateModule)


// WEBPACK FOOTER //
// ./src/views/report/modules/create_module.js